import { Flex } from 'components/Flex';
import { Fragment } from 'react';
import {
  FlexWrapper,
  JaneName,
  LabelText,
  ReviewNumber,
  ReviewText,
  H4,
  Text,
} from 'components/JaneModal/views/JaneDetailsView/ReviewsTab/ReviewsTab.styled';
import { Jane, Review } from 'types/graphql';
import { useFetchJaneByIdDataContext } from 'components/JaneModal/FetchJaneById.data.context';
import { SectionDivider } from 'components/ShiftModal/ShiftModal.styled';
import { ReviewCommentCard } from 'components/JaneModal/views/JaneDetailsView/ReviewsTab/ReviewCommentCard';
import { useTranslation } from 'react-i18next';
import { LoadingWrapper } from 'components/JaneModal/views/JaneDetailsView/GeneralTab/GeneralTab.styled';
import { BKJLoadingSpinner } from '@bookjane2/bookjane-design-library';
import { StarRating } from 'components/StarRating';

export const ReviewsTab = () => {
  const { data }: { data: Jane } = useFetchJaneByIdDataContext();
  const { t } = useTranslation();
  if (!data)
    return (
      <LoadingWrapper>
        <BKJLoadingSpinner variant="Default" />
      </LoadingWrapper>
    );
  const { shorthandName = '', customerReviews = { averageRating: '', count: '', reviews: [] } } =
    data;

  const averageRating = !customerReviews?.count ? 0 : Number(customerReviews?.averageRating) || 0;
  const ratingText = averageRating.toFixed(1);
  const renderRating = () => {
    if (customerReviews?.count === 0) {
      return '0.0';
    } else if (typeof averageRating === 'number') {
      return averageRating % 1 === 0 ? ratingText : averageRating;
    }
    return '0.0';
  };
  return (
    <Fragment>
      <FlexWrapper>
        <Flex flexDirection="column" gap="20px">
          <JaneName>{shorthandName}</JaneName>
          <Flex flexDirection="column" gap="8px">
            <LabelText>{t('team_member:OVERALL_RATING')}</LabelText>
            <Flex gap="10px" alignItems="center">
              <ReviewNumber>{renderRating()}</ReviewNumber>
              <Flex flexDirection="column" gap="8px">
                <StarRating rating={averageRating} />
                <ReviewText>
                  {t('team_memberModal:BASED_ON')} {customerReviews?.count}{' '}
                  {t('team_member:Reviews')}
                </ReviewText>
              </Flex>
            </Flex>
          </Flex>
        </Flex>
        <SectionDivider variant="Thin" />
        <Flex flexDirection="column" gap="32px" width="100%">
          <H4>{t('team_member:Reviews')}</H4>
          {customerReviews?.reviews.length > 0 ? (
            customerReviews?.reviews.map((review: Review) => <ReviewCommentCard review={review} />)
          ) : (
            <Flex height="432px" justifyContent="center" alignItems="center">
              <Text>{t('team_member:There_are_no_reviews_for_this_team_member')}</Text>
            </Flex>
          )}
        </Flex>
      </FlexWrapper>
    </Fragment>
  );
};
